module.exports = [{"nombre":"Centro de costo 40","equipo":[{"nombre":"Nicole Alejandra Tapia Migryk","correo":"Nicole.migryk@usach.cl","cargo":"Vinculación con el medio "},{"nombre":"Heraldo Martinez","correo":"Heraldo.martinez@hotmail.com","cargo":"Vinculación"},{"nombre":"Gonzalo Gonzales","correo":"Gonzalo@gmail.com","cargo":"Secretario"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/components/util/equipos.json
// module id = UiZ3
// module chunks = 5